<template>
    <div class="tableau-viz-container"></div>
</template>

<script>
    import { View } from '../vuex/models'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'TableauViz',
        props: {
            view: {
                type: View,
                required: true
            },
            brand: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                authToken: null
            }
        },
        async mounted() {
            await this.initViz()
        },
        computed: {
            ...mapGetters(['configuration']),
            url() {
                const baseUrl = this.configuration.tableauServer.root
                const siteId = this.configuration.tableauService.site

                return `${baseUrl}/trusted/${this.authToken}/t/${siteId}/views/${this.view.contentUrl}?:alerts=no&:customViews=no&:showShareOptions=no&:showAskData=no`
            }
        },
        methods: {
            ...mapActions(['logEvent', 'getAuthToken']),
            async initViz() {
                let containerDiv = document.querySelector(".tableau-viz-container")

                let options = {
                    width: '100%',
                    height: '100%'
                }

                if (this.brand) {
                    options.Brand = this.brand
                    options.Lender = this.brand
                    options['lender (copy)'] = this.brand
                    options['Choose Lender'] = this.brand
                    options['Lender Display'] = this.brand
                }

                let authTokenResponse = null
                let attempts = 0

                while (authTokenResponse == null && attempts < this.configuration.tableauService.maxAuthenticationAttempts) {
                    attempts++
                    const oktaToken = await this.$auth.getAccessToken()
                    authTokenResponse = await this.getAuthToken(oktaToken)
                }

                if (authTokenResponse == null) {
                    this.$router.push('/error')
                }

                this.authToken = authTokenResponse.data

                // Dispose of existing vizs
                window.tableau.VizManager.getVizs().forEach(v => {
                    v.dispose()
                })

                this.$store.commit('UPDATE_VIZ_LOADED', false)

                const viz = new window.tableau.Viz(containerDiv, this.url, options)

                viz.addEventListener('customViewLoad', this.onViewLoaded)

                await this.logEvent('View initialised')
            },
            onViewLoaded() {
                this.$emit('viewLoaded')
                this.$store.commit('UPDATE_VIZ_LOADED', true)
            }
        },
        watch: {
            view() {
                this.initViz()
            }
        }
    }
</script>

<style lang="scss">
    .tableau-viz-container {
        height: 100%;
    }
</style>
